<template>
  <div class="container-detail" v-if="loading">
    <div class="detail-header-buttons">
      <v-btn @click="back" style="width: auto !important" class="button-accept">
        <v-icon>mdi-chevron-left</v-icon>
        Вернуться к списку событий
      </v-btn>
      <div>
        <v-btn
          outlined
          color="var(--app-dark-blue-1)"
          style="width: auto !important; margin-right: 20px"
          class="button-accept-outlined"
          @click="getTable"
        >
          Скачать список участников
        </v-btn>
        <v-btn
          @click="goToEdit"
          style="width: auto !important"
          class="button-action"
        >
          Редактировать
        </v-btn>
      </div>
    </div>

    <div class="detail-main">
      <div class="detail-main-first-container" v-if="event">
        <div class="first-container-box">
          <div class="container-box-title">Заголовок</div>
          <div class="container-box-text">
            {{ event.name }}
          </div>
        </div>
        <div class="first-container-box">
          <div class="container-box-title">
            Описание события
            <v-icon
              @mouseover="openInfoDesc($event)"
              @mouseleave="showInfoDesc = false"
              color="#E0E0E0"
            >
              mdi-information
            </v-icon>
            <v-menu
              v-model="showInfoDesc"
              :position-x="xDesc"
              :position-y="yDesc"
              absolute
              offset-y
            >
              <v-card>
                <div class="menu-container">
                  <div class="menu-container-title">Описание события</div>
                  <div class="menu-container-text">
                    Отображается на экране детальной информации события
                  </div>
                  <v-img
                    src="../../../src/assets/event/descriptionEvent.png"
                  ></v-img>
                </div>
              </v-card>
            </v-menu>
          </div>
          <div class="container-box-text" v-html="event.description"></div>
        </div>
        <div class="first-container-box">
          <div class="container-box-title">
            Описание при предварительном просмотре
            <v-icon
              @mouseover="openInfoShort($event)"
              @mouseleave="showInfoShort = false"
              color="#E0E0E0"
            >
              mdi-information
            </v-icon>
            <v-menu
              v-model="showInfoShort"
              :position-x="xShort"
              :position-y="yShort"
              absolute
              offset-y
            >
              <v-card>
                <div class="menu-container">
                  <div class="menu-container-title">
                    Описание при предварительном просмотре
                  </div>
                  <div class="menu-container-text">
                    Отображается при предварительном просмотре в общем списке
                    событий
                  </div>
                  <v-img
                    src="../../../src/assets/event/shortDescription.png"
                  ></v-img>
                </div>
              </v-card>
            </v-menu>
          </div>
          <div class="container-box-text">
            {{ event.shortDescription }}
          </div>
        </div>
        <div class="first-container-box" v-if="event.regions">
          <div class="container-box-title">
            Регионы, которые получат уведомление о событии
          </div>
          <div
            class="container-box-text"
            v-if="this.regions.length != this.event.regions.length"
          >
            <span v-for="(item, index) in event.regions" :key="item.id">
              {{ item.name }}
              <span v-if="index + 1 != event.regions.length">,</span>
            </span>
          </div>
          <div class="container-box-text" v-else>Все регионы</div>
        </div>
        <div class="d-flex">
          <div class="first-container-box" style="margin-right: 40px">
            <div class="container-box-title">Дата события</div>
            <div class="container-box-text">
              <span v-if="event.hideEventTime">
                {{ event.plannedDate | moment("DD.MM.YYYY") }}
              </span>
              <span v-else>
                {{ event.plannedDate | moment("DD.MM.YYYY HH:mm") }}
              </span>
            </div>
          </div>

          <div class="first-container-box" style="margin-left: 40px">
            <div class="container-box-title">Дата публикации</div>
            <div class="container-box-text">
              {{ event.datePublish | moment("DD.MM.YYYY HH:mm") }}
            </div>
          </div>
        </div>
        <div
          class="first-container-box"
          v-if="event.place"
        >
          <div class="container-box-title">Место события</div>
          <div class="container-box-text">
            {{ event.place }}
          </div>
        </div>
        <div class="first-container-box">
          <div class="container-box-title">Тип события</div>
          <div class="container-box-text">
            {{ formatEventType(event.eventType) }}
          </div>
        </div>
        <div class="d-flex">
          <div class="first-container-box">
            <div class="container-box-title">Ссылка на событие</div>
            <div class="container-box-text">
              <a target="_blank" :href="event.link">{{ event.link }}</a>
            </div>
          </div>
        </div>
        <div class="first-container-box">
          <div class="container-box-title">Бейдж мероприятия</div>
          <div class="d-flex flex-column align-start">
            <div class="badge-switch-label">
              <v-switch
                class="switcher"
                v-model="badgeEnabled"
                hide-details
                color="var(--app-green-1)"
              ></v-switch>
              <span class="switch-label">Добавить бейдж на мероприятие</span>
            </div>
            <v-btn
              v-if="badgeEnabled"
              @click="goToBadgeConstructor"
              style="width: auto !important; margin-top: 32px"
              class="button-accept"
            >
              Перейти в конструктор бейджа
            </v-btn>
          </div>
        </div>
        <div class="first-container-box" v-if="event.files.length > 0">
          <div class="container-box-title">Вложенные файлы</div>
          <div class="container-box-text">
            <div v-for="(item, index) in event.files" :key="index">
              <v-icon> mdi-file-pdf-box </v-icon>
              <a style="margin-left: 8px" target="_blank" :href="item.file">{{
                item.name
              }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="detail-main-second-container">
        <div class="second-container-box">
          <div class="container-box-title">
            Изображение события
            <v-icon
              @mouseover="openInfoImg($event)"
              @mouseleave="showInfoImg = false"
              color="#E0E0E0"
            >
              mdi-information
            </v-icon>
          </div>
          <v-menu
            v-model="showInfoImg"
            :position-x="xImg"
            :position-y="yImg"
            absolute
            offset-y
          >
            <v-card>
              <div class="menu-container">
                <div class="menu-container-text">
                  Нажмите на изображение, чтобы увидеть его в полном размере
                </div>
              </div>
            </v-card>
          </v-menu>
        </div>

        <div>
          <v-simple-table v-if="event">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Формат</th>
                  <th class="text-left">Место отображенния</th>
                  <th class="text-left">Для смартфонов</th>
                  <th class="text-left">Для планшетов</th>
                </tr>
              </thead>
              <tbody>
                <tr style="height: 60px">
                  <td class="text-left">Главное изображение</td>
                  <td class="text-left">
                    Отображается на экране детальной информации события
                  </td>
                  <td class="text-left">
                    <img
                      @click="openDialogImg(event.smartphoneImage)"
                      v-if="event.smartphoneImage"
                      class="table-img"
                      :src="event.smartphoneImage"
                    />
                  </td>
                  <td class="text-left">
                    <img
                      @click="openDialogImg(event.tabletImage)"
                      v-if="event.tabletImage"
                      class="table-img"
                      :src="event.tabletImage"
                    />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <DialogImage
            v-if="previewImage"
            v-model="dialogImg"
            :src="previewImage"
          />
          <v-divider></v-divider>
        </div>

        <div class="second-container-box" style="margin-top: 40px">
          <div
            v-if="event.toSendPush || event.toSendPushWeekBefore"
            class="container-box-title"
          >
            Параметры уведомлений
          </div>
          <div v-if="event.toSendPush" class="container-box-onlytext">
            Рассылка уведомления при публикации события
          </div>
          <div v-if="event.toSendPushWeekBefore" class="container-box-onlytext">
            Рассылка уведомления за неделю до начала события
          </div>

          <div
            v-if="
              event.toShowInConference ||
              event.hideEventTime
            "
            class="container-box-title"
            style="margin-top: 40px"
          >
            Настройки события
          </div>
          <div v-if="event.toShowInConference" class="container-box-onlytext">
            Выводить на сайте конференции
          </div>
          <div v-if="event.hideEventTime" class="container-box-onlytext">
            Отображать только дату события
          </div>
          <!-- <div v-if="event.isTimezoneRequired" class="container-box-onlytext">
                       Учитывать временные зоны
                    </div> -->

          <div
            v-if="event.isRegistrationRequired"
            class="container-box-title"
            style="margin-top: 40px"
          >
            Параметры регистрации на событие
          </div>
          <div
            v-if="event.isRegistrationRequired"
            class="container-box-onlytext"
          >
            Требуется регистрация на событие (Отображать кнопку «Пойду»)
          </div>
          <div v-if="event.isPhotoRequired" class="container-box-onlytext">
            Требуется прикрепить фотографию
          </div>
          <div
            v-if="event.isCOVIDCertificateRequired"
            class="container-box-onlytext"
          >
            Требуется прикрепить COVID-сертификат
          </div>
          <div v-if="event.isUserDataRequired" class="container-box-onlytext">
            Отображать поля ввода паспортных данных и даты рождения при
            регистрации на событие
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    event: null,
    dialogImg: false,
    previewImage: null,
    imageWidth: 0,
    hideNews: false,

    showInfoImg: false,
    xImg: null,
    yImg: null,

    showInfoDesc: false,
    xDesc: null,
    yDesc: null,

    showInfoShort: false,
    xShort: null,
    yShort: null,

    regions: [],
    loading: false,

    badgeEnabled: false,
  }),
  methods: {
    getTable() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV2 + "/event/table", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            eventId: this.$route.params.id,
          },
        })
        .then((res) => {
          window.open(res.data.file, "_blank");
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    openInfoShort(e) {
      e.preventDefault();
      this.xShort = e.clientX + 10;
      this.yShort = e.clientY + 10;
      this.showInfoShort = true;
    },
    openInfoImg(e) {
      e.preventDefault();
      this.xImg = e.clientX + 10;
      this.yImg = e.clientY + 10;
      this.showInfoImg = true;
    },
    openInfoDesc(e) {
      e.preventDefault();
      this.xDesc = e.clientX + 10;
      this.yDesc = e.clientY + 10;
      this.showInfoDesc = true;
    },
    openDialogImg(src) {
      this.previewImage = src;
      this.dialogImg = true;
    },
    back() {
      this.$router.push({ name: "Events" });
    },
    goToBadgeConstructor() {
      this.$router.push({
        name: "EventBadgeConstructor",
        params: { id: this.$route.params.id },
      });
    },
    goToEdit() {
      this.$router.push({
        name: "EditEvent",
        params: { id: this.$route.params.id },
      });
    },
    getEvent() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV2 + "/event", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            eventId: this.$route.params.id,
          },
        })
        .then((res) => {
          this.event = res.data;
          this.loading = true;
        })
        .catch((err) => {
          this.loading = false;
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    formatEventType(type) {
      const eventTypeMap = {
        online_offline: "Онлайн/Оффлайн",
        online: "Онлайн",
        offline: "Оффлайн",
        "Онлайн/Оффлайн": "Онлайн/Оффлайн",
        Онлайн: "Онлайн",
        Оффлайн: "Оффлайн",
      };

      return eventTypeMap[type] || "Онлайн/Оффлайн";
    },
    getRigionsList() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/region/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.regions = res.data.items;
          this.getEvent();
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getBadge() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            `/events/badges/settings/event/${this.$route.params.id}`,
          {
            headers: {
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.badgeEnabled = true;
        })
        .catch((err) => {});
    },
  },
  created() {
    this.getEvent();
    this.getRigionsList();
    this.getBadge();
  },
};
</script>
<style lang="scss" scoped>
.container-detail {
  box-sizing: border-box;
  padding: 40px !important;

  .detail-header-buttons {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
  }

  .detail-main {
    display: flex;
    justify-content: space-between;

    .detail-main-first-container {
      width: 48%;

      .first-container-box {
        margin-bottom: 40px;

        .container-box-title {
          font-size: 24px;
          font-weight: 600;
        }

        .container-box-text {
          font-size: 18px;
          word-break: break-word;
          font-weight: 400;
        }

        .container-box-text-list {
          .container-box-text-list-item {
            display: flex;
            margin-bottom: 5px;

            .list-item-subtitle {
              font-size: 16px;
              font-weight: 600;
              color: #929292;
              width: 200px;
            }

            .list-item-text {
              font-size: 18px;
              font-weight: 400;
            }
          }
        }

        .badge-switch-label {
          margin-top: 24px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          gap: 24px;

          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
    }

    .detail-main-second-container {
      width: 48%;

      .table-img {
        cursor: pointer;
        height: 38px;
        object-fit: contain;
      }

      .second-container-box {
        width: 100%;

        .container-box-title {
          font-size: 24px;
          font-weight: 600;
        }

        .container-box-text {
          font-size: 18px;
          font-weight: 400;

          word-break: break-all;
        }

        .container-box-onlytext {
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
